<!--
 * @Author: yangbobolaa 994786855@qq.com
 * @Date: 2023-12-12 09:22:32
 * @LastEditors: yangbobolaa 994786855@qq.com
 * @LastEditTime: 2023-12-12 11:42:12
 * @FilePath: \backend\src\views\pddAfterSale\aftersale\List.vue
 * @Description: 商家中心 -- 拼多多管理 -- 售后列表
-->
<template>
  <y-view :loading="isLoading">
    <y-card>
      <query-form :data="formData" :form="dataForm.query" @search="handleSearch" @reset="handleReset"></query-form>
      <query-table ref="yTable" :initColumns="initColumns" :dataForm="dataForm" :handleList="handleList" @loadingClose="isLoading = false" @loadingOpen="isLoading = true"></query-table>
    </y-card>
    <log-popup ref="logPopup"></log-popup>
  </y-view>
</template>
<script>
import { MALL_REFUND_PAGE, MALL_REFUND_REFRESH, MALL_REFUND_SYNC, MALL_REFUND_SYNC_LOGISTICS } from "@/assets/modules/pinduooApiList";
import logPopup from "../components/logPopup.vue";
export default {
  components: { logPopup },
  data() {
    return {
      isLoading: false,
      formData: [
        { typeCode: "input", title: "售后单号", name: "refundId", placeholder: "请输入售后单号" },
        { typeCode: "input", title: "订单号", name: "orderSn", placeholder: "请输入订单号" },
        {
          typeCode: "select",
          title: "同步状态",
          name: "syncStatus",
          placeholder: "请选择同步状态",
          optionData: [
            { key: "0", value: "未同步" },
            { key: "1", value: "同步成功" },
            { key: "2", value: "同步失败" },
            { key: "3", value: "关闭" },
            { key: "4", value: "待推送物流信息" },
            { key: "5", value: "物流信息推送成功" },
            { key: "6", value: "物流信息推送失败" },
            { key: "7", value: "已作废/已驳回退货" },
          ],
        },
        { typeCode: "dateSectionView", title: "售后申请时间", name: "applyTime", start: "startApplyTime", end: "endApplyTime", placeholder: "请选择" },
        { typeCode: "dateSectionView", title: "售后拉取时间", name: "createTime", start: "startCreateTime", end: "endCreateTime", placeholder: "请选择" },
      ],
      dataForm: {
        baseUrl: true,
        url: MALL_REFUND_PAGE,
        tableH: "calc(100vh - 258px)",
        hasCheckbox: true,
        selectedKeys: [],
        selectedRows: [],
        checkboxKey: "refundId",
        rightFixedNumber: 1,
        query: {
          refundId: "",
          orderSn: "",
          syncStatus: "",
          startCreateTime: "",
          endCreateTime: "",
          startApplyTime: "",
          endApplyTime: "",
        }, //列表查询条件字段
      },
      handleList: [
        { type: "btn", name: "同步售后", btnType: "primary", btnClick: (val) => this.handleLinkToDetail({}, 1) },
        { type: "btn", name: "退货物流同步", btnType: "primary", btnClick: (val) => this.handleLinkToDetail({}, 2) },
      ],
    };
  },
  methods: {
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w ? w : 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },

    /** 初始化表格 */
    initColumns() {
      let tableItem = [
        { name: "售后单号", style: this.tableStyle(150), customRender: (row) => <div>{row.refundId ? row.refundId : "——"}</div> },
        { name: "订单号", style: this.tableStyle(160), customRender: (row) => <div>{row.orderSn ? row.orderSn : "——"}</div> },
        { name: "渝欧售后单号", style: this.tableStyle(150), customRender: (row) => <div>{row.lddRefundSn ? row.lddRefundSn : "——"}</div> },
        { name: "同步状态", style: this.tableStyle(120), customRender: (row) => <div>{row.syncStatusName ? row.syncStatusName : "——"}</div> },
        { name: "售后状态", style: this.tableStyle(160), customRender: (row) => <div>{row.refundStatusName ? row.refundStatusName : "——"}</div> },
        { name: "退款金额", style: this.tableStyle(120), customRender: (row) => <div>{row.refundAmount ? row.refundAmount : "——"}</div> },
        { name: "退货运单号", style: this.tableStyle(150), customRender: (row) => <div>{row.trackingCode ? row.trackingCode : "——"}</div> },
        { name: "售后申请时间", style: this.tableStyle(140), customRender: (row) => <div>{row.applyTime ? row.applyTime : "——"}</div> },
        { name: "售后拉取时间", style: this.tableStyle(140), customRender: (row) => <div>{row.createTime ? row.createTime : "——"}</div> },
        {
          name: "操作",
          style: this.tableStyle(130),
          customRender: (row) => (
            <div>
              <a class="table-handle-text-color" href="javascript:;" onclick={() => this.handleLinkToDetail(row, 3)}>
                日志&#12288;
              </a>
              <a class="table-handle-text-color" href="javascript:;" onclick={() => this.handleLinkToDetail(row, 4)}>
                更新售后详情
              </a>
            </div>
          ),
        },
      ];
      return tableItem;
    },

    /** 更新售后详情操作 */
    onRefreshAfterSaleDetail(row) {
      this.$dialog({
        title: "提示",
        content: `确认执行当前操作？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: MALL_REFUND_REFRESH, para: { refundId: row.refundId } })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.$refs.yTable.init();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 批量同步售后操作 */
    onBatchSyncAfterSale() {
      this.$dialog({
        title: "提示",
        content: `确认执行当前操作？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            baseUrl: window.__CONFIG__.pinduoo_url,
            api: MALL_REFUND_SYNC,
            para: { refundIdList: this.dataForm.selectedKeys },
          })
            .then(() => {
              this.isLoading = false;
              this.dataForm.selectedKeys = [];
              this.dataForm.selectedRows = [];
              this.$root.tip("操作成功", "success");
              this.$refs.yTable.init();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 批量同步退货物流操作 */
    onBatchSyncReturnLogistics() {
      this.$dialog({
        title: "提示",
        content: `确认执行当前操作？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            baseUrl: window.__CONFIG__.pinduoo_url,
            api: MALL_REFUND_SYNC_LOGISTICS,
            para: { refundIdList: this.dataForm.selectedKeys },
          })
            .then(() => {
              this.isLoading = false;
              this.dataForm.selectedKeys = [];
              this.dataForm.selectedRows = [];
              this.$root.tip("操作成功", "success");
              this.$refs.yTable.init();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 点击同步售后/退货物流同步/日志/更新售后详情操作 */
    handleLinkToDetail(row, showType) {
      // showType 1:同步售后，2:退货物流同步，3:日志，4:更新售后详情
      switch (showType) {
        case 1:
          if (this.dataForm.selectedKeys.length === 0) return this.$root.tip("请选择需要批量同步售后的单据", "error");
          this.onBatchSyncAfterSale();
          break;
        case 2:
          if (this.dataForm.selectedKeys.length === 0) return this.$root.tip("请选择需要批量同步退货物流的单据", "error");
          this.onBatchSyncReturnLogistics();
          break;
        case 3:
          this.$refs.logPopup.isShow = true;
          this.$refs.logPopup.para.refundId = row.refundId;
          this.$refs.logPopup.init();
          break;

        default:
          this.onRefreshAfterSaleDetail(row);
          break;
      }
    },

    /** 根据条件搜索列表数据 */
    handleSearch(params) {
      this.isLoading = true;
      this.dataForm.query = params;
      this.dataForm.selectedRows = [];
      this.dataForm.selectedKeys = [];
      this.$refs.yTable.reload();
    },

    /** 重置列表查询条件 */
    handleReset() {
      this.isLoading = true;
      this.dataForm.selectedRows = [];
      this.dataForm.selectedKeys = [];
      this.$refs.yTable.reload();
    },
  },

  created() {
    this.isLoading = true;
  },

  beforeRouteUpdate(to, from, next) {
    this.isLoading = true;
    this.$refs.yTable.refresh();
    next();
  },
};
</script>
<style module="css" lang="postcss">
.popup_inputW {
  width: 440px !important;
}
</style>
